<template>
    <v-dialog v-model="dialog" max-width="700px">
      <template v-slot:activator="{ on, attrs }">
        <v-icon
          color="primary"
          dark
          v-bind="attrs"
          v-on="on"
          small
          class="mx-1"
          >fas fa-tasks
        </v-icon>
      </template>
      <v-card>
        <v-card-title>
        <v-row class="ma-0">
        <v-col cols="5">
          <span class="headline">Payments</span>
        </v-col>
        <v-col cols="4">
        </v-col>
        <v-col cols="3">
          <AddPayment :subscriptionid="subscriptionid"/>
        </v-col>
        </v-row>
        </v-card-title>
        <v-card-text>
            <v-row>
                <v-col cols="12" sm="12">
                <v-simple-table class="w-100">
                    <template v-slot:default>
                        <thead>
                            <tr>
                            <th>From Date</th>
                            <th>To Date</th>
                            <th>Amount</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="payment in payments" :key="payment.id">
                                <td>{{ payment.from_date }}</td>
                                <td>{{ payment.to_date }}</td>
                                <td>{{ payment.amount }}</td>
                            </tr>
                        </tbody>
                    </template>
                </v-simple-table>
                </v-col>
            </v-row>
        </v-card-text>
          <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
import AddPayment from './AddPayment.vue';
//import sendMessage from '../../apis/sendMessage.js';
  export default {
    components: {
        AddPayment
    },
    props : {
        payments: Array,
        subscriptionid : Number
    },
    data: function() {
      return {
        dialog: false,
        status : '',
        priority: '',
      }
    },
}
</script>